export const practiceAreas = [
  {
    id: 1,
    title: "Civil & Commercial Litigation",
    description: "Expert representation in complex civil and commercial disputes, including contract disputes, property litigation, and business conflicts. Our team has extensive experience in trial advocacy and dispute resolution.",
    icon: "Scale"
  },
  {
    id: 2,
    title: "Real Estate Law",
    description: "Comprehensive legal services for property transactions, title verification, property disputes, land acquisition, and real estate development. We ensure smooth transactions and protect your property interests.",
    icon: "Building2"
  },
  {
    id: 3,
    title: "Family Law",
    description: "Compassionate and professional handling of family matters including divorce, custody, maintenance, adoption, and inheritance disputes. We provide sensitive legal guidance during challenging times.",
    icon: "Users"
  },
  {
    id: 4,
    title: "Corporate Law",
    description: "Strategic legal counsel for businesses including company formation, compliance, contracts, mergers & acquisitions, and corporate governance. We help businesses navigate complex legal landscapes.",
    icon: "Briefcase"
  },
  {
    id: 5,
    title: "White Collar Crimes",
    description: "Specialized defense in white collar crime matters including fraud, embezzlement, money laundering, corruption cases, and financial crimes. Protecting your reputation and rights with vigorous defense strategies.",
    icon: "ShieldAlert"
  },
  {
    id: 6,
    title: "Public Law",
    description: "Expert handling of constitutional matters, writ petitions, public interest litigation, administrative law disputes, and judicial review. Upholding citizens' rights and ensuring governmental accountability.",
    icon: "Landmark"
  },
  {
    id: 7,
    title: "Transaction Advisory",
    description: "Strategic advisory services for complex business transactions including due diligence, structuring, negotiation, and documentation. Ensuring legally sound transactions that protect client interests and maximize value.",
    icon: "FileText"
  },
  {
    id: 8,
    title: "Arbitration and Conciliation",
    description: "Expert representation in domestic and international arbitration proceedings. Skilled in dispute resolution through arbitration, providing efficient alternatives to traditional litigation with expertise in arbitration laws and procedures.",
    icon: "Gavel"
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "Understanding Property Rights in Karnataka",
    excerpt: "A comprehensive guide to property ownership, registration, and rights under Karnataka's legal framework. Learn about the essential documents and procedures.",
    date: "December 15, 2024",
    category: "Real Estate",
    content: "Property rights in Karnataka are governed by various statutes including the Transfer of Property Act, 1882, and the Karnataka Land Revenue Act. Understanding these laws is crucial for property owners and buyers..."
  },
  {
    id: 2,
    title: "Corporate Compliance: Key Requirements for 2024",
    excerpt: "Stay updated with the latest corporate compliance requirements including annual filings, board meetings, and regulatory changes that affect your business.",
    date: "December 10, 2024",
    category: "Corporate Law",
    content: "Corporate compliance is an ever-evolving landscape. In 2024, companies must pay special attention to new MCA regulations, updated CSR norms, and enhanced disclosure requirements..."
  },
  {
    id: 3,
    title: "Navigating Commercial Disputes: Alternative Resolution Methods",
    excerpt: "Explore efficient alternatives to lengthy court proceedings including arbitration, mediation, and conciliation for resolving commercial disputes.",
    date: "December 5, 2024",
    category: "Litigation",
    content: "While traditional litigation remains an option, alternative dispute resolution methods offer faster, more cost-effective solutions for commercial conflicts. Arbitration has gained significant traction..."
  },
  {
    id: 4,
    title: "Child Custody Laws: What Parents Need to Know",
    excerpt: "Essential information about child custody determinations, visitation rights, and factors courts consider when deciding custody matters in India.",
    date: "November 28, 2024",
    category: "Family Law",
    content: "Child custody decisions are guided by the paramount consideration of the child's welfare. Courts examine multiple factors including the child's age, preferences, parental capability..."
  },
  {
    id: 5,
    title: "Recent Amendments to Contract Act: Impact on Businesses",
    excerpt: "Analysis of recent judicial interpretations and amendments affecting commercial contracts and what businesses should know to protect their interests.",
    date: "November 20, 2024",
    category: "Corporate Law",
    content: "The Indian Contract Act, 1872, continues to evolve through judicial interpretations. Recent Supreme Court judgments have clarified several aspects of force majeure clauses..."
  },
  {
    id: 6,
    title: "Real Estate Investment Trusts (REITs): Legal Framework",
    excerpt: "Understanding the regulatory framework, investment opportunities, and legal considerations for REITs in India's growing real estate market.",
    date: "November 15, 2024",
    category: "Real Estate",
    content: "REITs have emerged as an attractive investment avenue in India's real estate sector. Governed by SEBI regulations, REITs allow investors to participate in income-generating real estate..."
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "D J Govindaraju",
    title: "Senior Partner",
    description: "With over 25 years of experience in civil litigation and corporate law, D J Govindaraju leads the firm with expertise in complex legal matters."
  },
  {
    id: 2,
    name: "Associate Team",
    title: "Legal Associates",
    description: "Our dedicated team of legal associates brings diverse expertise across various practice areas, ensuring comprehensive legal solutions."
  }
];

export const firmInfo = {
  name: "D J Govindaraju and Associates",
  tagline: "Expertise Driven Legal Practice",
  yearsOfExperience: "25+ Years",
  description: "Delivering excellence in legal practice across Civil & Commercial Litigation, Real Estate, Family Law, Corporate matters, White Collar Crimes, Public Law, Transaction Advisory, and Arbitration and Conciliation.",
  address: "3/2, 2nd Floor, Thimmaiah Towers, 1st Main, 1st Cross Rd, near Olympic Sports, Gandhi Nagar, Bengaluru, Karnataka 560009",
  phone: "+91 9845871216",
  email: "djg.advocate@gmail.com",
  hours: "9:00 AM - 8:00 PM, Monday - Saturday",
  logo: "https://customer-assets.emergentagent.com/job_legal-tan-hub/artifacts/x8scleay_WhatsApp%20Image%202025-12-04%20at%2008.03.07.jpeg"
};